import {Component} from '@angular/core';
import {TabParentDecisionComponent} from '../generics/tab-parent-decision/tab-parent-decision.component';
import {Tab} from '../../tabs/tab';

@Component({
    templateUrl: '../generics/tab-parent-decision/tab-parent-decision.component.html',
    host: { 'class': 'cell auto grid-y decisionContainer _staff' },
    standalone: false
})export class StaffDecisionComponent extends TabParentDecisionComponent {

    constructor() {
        super([
                new Tab(
                    'decisions.dashboard.staff.decision',
                    '/session/decisions/staff',
                    false)
            ], 'decisions.dashboard.staff.decision',
            'decisions.animator.mark',
            '/session/decisions/staff/mark'
        );
    }
}
